import React, { useCallback, memo } from 'react';
import Button from 'components/Button';
import withLazyStyle from 'components/LazyStyle';
import style from './belt.css?lazy';

interface BeltProps {
  ctaText: string;
  ctaUrl: string;
  onCtaClick: () => void;
}

const Belt = ({ ctaText, ctaUrl, onCtaClick }: BeltProps) => {
  const handleCtaClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      onCtaClick();
      e.stopPropagation();
    },
    [onCtaClick]
  );

  return (
    <section className="offerBanner__belt">
      {ctaUrl && (
        <Button
          name="offerCtaButton"
          className="button__grey offerBanner__primaryButton"
          tag="Link"
          href={ctaUrl}
          buttonText={ctaText}
          onClick={handleCtaClick}
        />
      )}
    </section>
  );
};

export default memo(withLazyStyle(style)(Belt));
